import React from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { ShortTestimonials } from './components/ShortTestimonials';
import { ToolPreviewCarousel } from './components/ToolPreviewCarousel';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { FinalGuarantee } from './components/FinalGuarantee';
import { PurchasePopup } from './components/PurchasePopup';
import { GYM_BG } from './data/content';
export function App() {
  return <div className="landing-light relative min-h-full w-full overflow-x-hidden bg-[#f4f6ec] text-[#182218]" data-id="element-0" data-mp="2wk0ah3dhcrwk">
      {/* Soft gym texture, kept subtle behind the light interface */}
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-cover bg-center opacity-[0.12]" style={{
      backgroundImage: `url(${GYM_BG})`
    }} data-id="element-1" data-mp="28sbend1g9lav" />
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-[#f4f6ec]/90 backdrop-blur-sm" data-id="element-2" data-mp="3ihv1odb3qjic" />

      {/* Content */}
      <main className="relative z-10 mx-auto w-full" data-id="element-3" data-mp="3rbr9so7flver">
        <Hero data-id="element-4" data-mp="3rd18nfm3z7mg" />
        <Problems data-id="element-5" data-mp="3relvej26lm9r" />
        <Modules data-id="element-6" data-mp="5orh0l86u6j" />
        <Bonuses data-id="element-7" data-mp="6817u0q2c9h" />
        <ShortTestimonials data-id="element-8" data-mp="4n6a3ahwrb3" />
        <ToolPreviewCarousel data-id="element-9" data-mp="82jt1oitsae" />
        <Comparison data-id="element-10" data-mp="2zld1r8m3ndb0" />
        <FinalOffer data-id="element-11" data-mp="2zm4y4lnitf2c" />
        <Objections data-id="element-12" data-mp="2zmo4d53t6f0j" />
        <FinalGuarantee data-id="element-13" data-mp="2zn6cayzu2hoa" />

        <footer className="px-5 pb-28 pt-4 text-center" data-id="element-14" data-mp="33mf1dqjxhrdi">
          <p className="text-[11px] leading-relaxed text-neutral-500" data-id="element-15" data-mp="33myn7icp8zwt">
            HYROX Definitivo 360 — Edición Coach · Producto digital · Todos los
            derechos reservados.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-16" data-mp="nvj4pj9gikrb" />
    </div>;
}